export default __webpack_public_path__ + "static/SR France - Microbial derived - Statement-cbebc21ad282cab4016bf1f459b2facf.pdf";